import { getEnabledElement } from "component/toolManager/enabledElements.js";
import CustomEvent from "core/customEvent/index";
import Config from "config";
/**
 * @public
 * @class PanTool
 * @memberof Tools
 *
 * @classdesc Tool for panning the image.
 * @extends Tools.Base.BaseTool
 */

export default class PanTool {
  onMouseDrag = (evt) => {
    const eventData = evt.detail;
    const { element: enabledElement } = eventData;

    let viewport = enabledElement.viewport;

    const translation = this._getTranslation(eventData);
    this._applyTranslation(viewport, translation);
    enabledElement.needsRedraw = true;
  };

  onMouseUp = (evt) => {
    const eventData = evt.detail;
    var elementStub = getEnabledElement(eventData.element.element);
    /**
     * 1x1 포커스 모드일때는 Pan을 동기화 하지 않는다.
     */
    // eslint-disable-next-line no-unused-expressions
    let focusDCMViewIdx = Config.rootStore.gridLayoutStore.getFocusOneDCMViewIdx();
    if (focusDCMViewIdx !== -1) {
      return;
    }
    // PAN 동작이 완료된 후, 변경 이벤트를 전송함
    // 동기화는 이 시점에 수행됨
    CustomEvent.triggerEvent(
      eventData.element.element,
      CustomEvent.EVENTS.PAN_ZOOM_CHANGED,
      elementStub
    );
  };

  _getTranslation(eventData) {
    const { element, image, deltaPoints } = eventData;
    let viewport = element.viewport;

    let widthScale = viewport.scale;
    let heightScale = viewport.scale;

    if (image.rowPixelSpacing < image.columnPixelSpacing) {
      widthScale *= image.columnPixelSpacing / image.rowPixelSpacing;
    } else if (image.columnPixelSpacing < image.rowPixelSpacing) {
      heightScale *= image.rowPixelSpacing / image.columnPixelSpacing;
    }

    return {
      x: deltaPoints.page.x / widthScale,
      y: deltaPoints.page.y / heightScale,
    };
  }

  _applyTranslation(viewport, translation) {
    viewport.translation.x += translation.x;
    viewport.translation.y += translation.y;
  }
}
